import React from 'react';
import PropTypes from 'prop-types';

import { get } from 'dpl/shared/utils/object';
import FullPageQuizQuestion from 'dpl/components/FullPageQuiz/FullPageQuizQuestion';
import FullPageQuizTextInput from 'dpl/components/FullPageQuiz/FullPageQuizTextInput';

const INPUT_NAME = 'primary_caretaker_description';

export default function QuizPrimaryCaretakerDescriptionQuestion({
  formState,
  handleNextClick,
  onChange,
  isValid
}) {
  const primaryCaretakerDescription = get(formState, INPUT_NAME, '');

  return (
    <div className="AdoptionApplicationQuizPrimaryCaretakerDescriptionQuestion">
      <FullPageQuizQuestion
        handleNextClick={handleNextClick}
        isValid={isValid}
        title="Who will be the primary caretaker of your puppy?"
      >
        <FullPageQuizTextInput
          Tag="textarea"
          name={INPUT_NAME}
          onChange={onChange}
          value={primaryCaretakerDescription || ''}
        />
      </FullPageQuizQuestion>
    </div>
  );
}

QuizPrimaryCaretakerDescriptionQuestion.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  formState: PropTypes.object.isRequired,
  handleNextClick: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  isValid: PropTypes.bool.isRequired
};
